import React from "react";
import {AlipayIcon, PaymentTilContent, PaymentTipArrow, WechatPayIcon} from "./styles";



export default function PaymentTip() {
    return <>

        <PaymentTilContent>
            <PaymentTipArrow />
            <div style={{marginBottom: 10}}>
                <AlipayIcon />
                <WechatPayIcon />
            </div>
            <div>
                请使用微信或支付宝扫码支付
            </div>

            <div>
                同意并接受
                <a href={`//niu.niuxyx.com/tos.html`} target={"_blank"}>《讯毅支付服务协议》</a>
            </div>
        </PaymentTilContent>
    </>
}
